class rechargeWidget extends HTMLElement {
  constructor() {
    super();
    
    this.optionSelectors = this.querySelectorAll('[data-purchase_type]');
    this.optionSelectors.forEach(option => option.addEventListener('click', this._toggleOptions.bind(this)));

    this.sellingPlans = this.querySelectorAll('[data-purchase_type="subscription"] .custom-dropdown');
    this.sellingPlans.forEach(plan => plan.addEventListener('change', this._changeSellingPlan.bind(this)));

    // Add direct click handler for dropdown options
    this.addEventListener('click', (event) => {
      const target = event.target;
      let optionItem = target.closest('li');
      let optionText = null;
      let customSelect = null;

      // Handle radio input clicks
      if (target.matches('input[type="radio"]')) {
        const purchaseType = target.closest('[data-purchase_type]');
        if (purchaseType) {
          const optionTxt = purchaseType.querySelector('.option_txt');
          if (optionTxt) {
            optionText = optionTxt;
            customSelect = purchaseType.querySelector('custom-select');
          }
        }
      } 
      // Handle list item clicks
      else if (optionItem) {
        customSelect = optionItem.closest('custom-select');
        if (customSelect) {
          optionText = customSelect.querySelector('.option_txt');
        }
      }

      if (!optionText || !customSelect) return;

      // Update text content
      if (optionItem) {
        optionText.textContent = optionItem.getAttribute('data-value');
        
        // Update selected state
        customSelect.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
        optionItem.classList.add('selected');
        
        // Update radio input
        const radioInput = optionItem.querySelector('input[type="radio"]');
        if (radioInput) {
          radioInput.checked = true;
          radioInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  connectedCallback() {
    const form = this.closest('form');
    if (!form) return;

    // Initialize data for single-variant products (multi-variant products are handled by VariantSelects)
    setTimeout(() => {
      if (!form.querySelector('variant-selects')) {
        this.initializeSingleVariantProduct();
      }
    }, 50);
    
    // Call _toggleOptions on page load to set initial discount percentages
    setTimeout(() => {
      const mockEvent = { target: this.querySelector('input[type="radio"]:checked') || this.querySelector('input[type="radio"]') };
      if (mockEvent.target) {
        this._toggleOptions(mockEvent);
      }
      
      // Filter selling plans on initial load
      this.filterSellingPlansForVariant();
    }, 100);
    
  }

  initializeSingleVariantProduct() {
    const form = this.closest('form');
    let currentVariant = window.globalVariables?.product?.currentVariant;
    
    // For single-variant products, get variant from product data if not set
    if (!currentVariant && window.globalVariables?.product?.variants) {
      currentVariant = window.globalVariables.product.variants[0];
      
      // Get metafields from the DOM JSON script for single-variant products
      const metafieldsScript = form.querySelector('[data-variantJSON-metafields]');
      if (metafieldsScript && metafieldsScript.textContent) {
        try {
          const variantMetafields = JSON.parse(metafieldsScript.textContent);
          const variantId = currentVariant.id.toString();
          if (variantMetafields[variantId]) {
            currentVariant.metafields = variantMetafields[variantId];
          }
        } catch (error) {
          // Silently continue if metafields can't be parsed
        }
      }
      
      // Set it globally so other code can use it
      if (!window.globalVariables.product.currentVariant) {
        window.globalVariables.product.currentVariant = currentVariant;
      }
    }
    
    if (!currentVariant) {
      return;
    }
    
    // Populate data-onetime-price elements (same logic as VariantSelects)
    form.querySelectorAll('[data-onetime-price]').forEach((ele) => {
      ele.innerHTML = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);
      
      // Set onetime_compare_price attribute - check selling_plan_allocations first, then compare_at_price
      let comparePrice = null;
      if (currentVariant.selling_plan_allocations && currentVariant.selling_plan_allocations.length > 0) {
        comparePrice = currentVariant.selling_plan_allocations[0].compare_at_price;
      } else if (currentVariant.compare_at_price != null) {
        comparePrice = currentVariant.compare_at_price;
      }
      
      if (comparePrice != null) {
        let onetime_com_price = Utility.formatMoney(comparePrice, window.globalVariables.money_format);
        ele.setAttribute("onetime_compare_price", onetime_com_price);
      }
    });

    // Populate data-subscription_price elements
    form.querySelectorAll('[data-subscription_price]').forEach((ele) => {
      if (currentVariant.selling_plan_allocations && currentVariant.selling_plan_allocations.length > 0) {
        let subscription_price = Utility.formatMoney(currentVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);
        ele.innerHTML = subscription_price;
        
        if (currentVariant.selling_plan_allocations[0].compare_at_price) {
          let subscription_compare = Utility.formatMoney(currentVariant.selling_plan_allocations[0].compare_at_price, window.globalVariables.money_format);
          ele.setAttribute("subscription_compare_price", subscription_compare);
        }
      }
    });

    // Handle first order pricing for single-variant products
    const firstOrderPricingElement = form.querySelector('[data-first-order-pricing]');
    if (firstOrderPricingElement && currentVariant.selling_plan_allocations && currentVariant.selling_plan_allocations.length > 0) {
      const firstAllocation = currentVariant.selling_plan_allocations[0];
      
      // Check for metafield override first
      const futureOrderDiscount = currentVariant.metafields?.future_order_hardcoded_discount;
      
      if (futureOrderDiscount) {
        // Use metafield override - calculate the future order price based on the discount percentage
        const firstOrderPrice = firstAllocation.price_adjustments[0].price;
        const originalPrice = currentVariant.compare_at_price || currentVariant.price;
        
        // Calculate future order price using the metafield discount percentage
        const discountDecimal = parseInt(futureOrderDiscount) / 100;
        const calculatedFutureOrderPrice = originalPrice - (originalPrice * discountDecimal);
        
        // Calculate discount percentages
        const firstDiscountPercent = Math.round(((originalPrice - firstOrderPrice) / originalPrice) * 100);
        const futureDiscountPercent = parseInt(futureOrderDiscount);
        
        // Update the pricing block with metafield override
        firstOrderPricingElement.innerHTML = `
          First order <span class="first-order-price fw-bold">${Utility.formatMoney(firstOrderPrice, window.globalVariables.money_format)} (${firstDiscountPercent}% off)</span>, 
          then <span class="secondary-order-price fw-bold">${Utility.formatMoney(calculatedFutureOrderPrice, window.globalVariables.money_format)} (${futureDiscountPercent}% off)</span> future orders
        `;
        
        // Show the element
        firstOrderPricingElement.style.display = '';
      } else if (firstAllocation.price_adjustments && firstAllocation.price_adjustments.length >= 2) {
        // Use normal Recharge logic
        const firstOrderPrice = firstAllocation.price_adjustments[0].price;
        const futureOrderPrice = firstAllocation.price_adjustments[1].price;
        const originalPrice = currentVariant.compare_at_price || currentVariant.price;
        
        // Only show pricing block if first order has a discount
        if (firstOrderPrice < futureOrderPrice) {
          // Calculate discount percentages
          const firstDiscountPercent = Math.round(((originalPrice - firstOrderPrice) / originalPrice) * 100);
          const futureDiscountPercent = Math.round(((originalPrice - futureOrderPrice) / originalPrice) * 100);
          
          // Update the pricing block
          firstOrderPricingElement.innerHTML = `
            First order <span class="first-order-price fw-bold">${Utility.formatMoney(firstOrderPrice, window.globalVariables.money_format)} (${firstDiscountPercent}% off)</span>, 
            then <span class="secondary-order-price fw-bold">${Utility.formatMoney(futureOrderPrice, window.globalVariables.money_format)} (${futureDiscountPercent}% off)</span> future orders
          `;
          
          // Show the element
          firstOrderPricingElement.style.display = '';
        } else {
          // First order same as recurring - hide the element
          firstOrderPricingElement.style.display = 'none';
        }
      } else {
        // No price adjustments - hide the element
        firstOrderPricingElement.style.display = 'none';
      }
    }

  }

  _toggleOptions(event){
    this.form = event.target.closest('form');

    if (this.form.closest('[data-product-container]') && this.form.querySelector('recharge-widget')) {
      // When called from a real user click on a [data-purchase_type] container,
      // use event.currentTarget to determine the selected type.  This fixes a
      // timing problem where clicking content that lives OUTSIDE the <label> but
      // INSIDE the container (e.g. [data-first-order-pricing]) fires the
      // container's click event without checking the radio, so reading
      // [name="selling_plan"]:checked would still return the old value.
      const clickedContainer = (typeof event.currentTarget?.getAttribute === 'function'
        && event.currentTarget.getAttribute('data-purchase_type'))
        ? event.currentTarget
        : null;

      if (clickedContainer) {
        this.type = clickedContainer.getAttribute('data-purchase_type');
        // Programmatically check the correct selling_plan radio so that
        // subsequent code (and FormData serialization) sees the right value.
        const targetRadio = this.form.querySelector(
          `[data-purchase_type="${this.type}"] input[name="selling_plan"]`
        );
        if (targetRadio && !targetRadio.checked) {
          targetRadio.checked = true;
        }
      } else {
        // Programmatic call (page-load mock event, variant-selects swatch change,
        // etc.) — fall back to reading the radio state directly.
        this.type = this.form.querySelector('[name="selling_plan"]:checked')
          ?.closest('[data-purchase_type]')?.getAttribute('data-purchase_type');
      }
    }
    
    // Get current button state
    const currentButton = this.form.closest('[data-product-container]').querySelector('[name="add"]');
    const isSoldOut = currentButton?.disabled || (currentButton?.querySelector('.add-text')?.textContent?.includes(window.variantStrings?.soldOut ?? 'Sold out') ?? false);

    if (this.type == 'onetime') {
      // Get current variant to ensure we use the latest variant's pricing
      const currentVariant = window.globalVariables?.product?.currentVariant;
      const onetimePriceElement = this.form.querySelector('[data-onetime-price]');
      const currentPriceElement = this.form.closest('[data-product-container]')?.querySelector('[data-current-price]');
      
      let onetime_price = '';
      if (onetimePriceElement && currentPriceElement) {
        onetime_price = onetimePriceElement.innerHTML;
        currentPriceElement.innerHTML = onetime_price;
      }
      // Fallback to current variant price if element is missing or empty
      if (!onetime_price && currentVariant?.price) {
        onetime_price = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);
      }

      // Use current variant's compare_at_price instead of potentially stale attribute
      let onetime_compare_price = '';
      if (currentVariant && currentVariant.compare_at_price) {
        onetime_compare_price = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
      } else {
        // Fallback to attribute if no current variant
        onetime_compare_price = this.form.querySelector('[data-onetime-price]')?.getAttribute("onetime_compare_price") || '';
      }
      
      const comparePriceElement = this.form.closest('[data-product-container]')?.querySelector('[data-current-com-price]');
      if (comparePriceElement) {
        comparePriceElement.innerHTML = onetime_compare_price;
      }
      
      // Check if there's a real discount (compare price > regular price)
      // Only proceed if onetime_price is available
      if (onetime_price) {
        const onetimePriceValue = parseFloat(onetime_price.replace(/[^0-9.-]+/g, ""));
        const onetimeComparePriceValue = onetime_compare_price ? parseFloat(onetime_compare_price.replace(/[^0-9.-]+/g, "")) : 0;
        const hasRealDiscount = onetime_compare_price && onetime_compare_price.length > 0 && onetimeComparePriceValue > onetimePriceValue;
        
        const compareOutPriceElement = this.form.closest('[data-product-container]')?.querySelector('[data-current-com-price]');
        
        if (hasRealDiscount) {
          // Show discount styling: sale text and crossed-out compare price
          if (currentPriceElement) {
            currentPriceElement.classList.add('rc-price--sale');
          }
          if (compareOutPriceElement) {
            compareOutPriceElement.style.display = '';
          }
        } else {
          // No real discount: remove sale styling and hide crossed-out price
          if (currentPriceElement) {
            currentPriceElement.classList.remove('rc-price--sale');
          }
          if (compareOutPriceElement) {
            compareOutPriceElement.style.display = 'none';
          }
        }
      }

      // Create button text based on sold out state
      const buttonText = isSoldOut
        ? window.variantStrings.soldOut
        : window.variantStrings.addToCart;

      // Update main add to cart button
      const addButton = this.form.closest('[data-product-container]')?.querySelector('[name="add"]');
      const addButtonText = addButton?.querySelector('.add-text');
      
      if (addButtonText) {
        addButtonText.innerHTML = buttonText;
      }
      if (addButton) {
        addButton.disabled = isSoldOut;
      }

      // Update sticky add to cart buttons
      document.querySelectorAll('[data-atc-out]')?.forEach(ele => {
        ele.innerHTML = `<span class="add-text">${buttonText}</span><span class="spinner-border block__add-to-cart-spinner"></span>`;
        ele.disabled = isSoldOut;
      });

      // Update sticky product details button
      const stickyButton = document.querySelector('.product-sticky-container [data-atc-out]');
      if (stickyButton) {
        stickyButton.innerHTML = `<span class="add-text">${buttonText}</span><span class="spinner-border block__add-to-cart-spinner"></span>`;
        stickyButton.disabled = isSoldOut;
      }

      let $variantGRP = null;
      $variantGRP = this.form.querySelectorAll('.custom-plan-wrapper > ul > li');

      if($variantGRP != null){
        $variantGRP.forEach((x) => {

          let regularP = x.querySelector('label [data-grp-price]').getAttribute('data-regular-price');
          let comparePrice = x.querySelector("label [data-grp-com-price]").getAttribute("data-regular-com-price");

          // Check if there's a meaningful discount difference
          const discountWrapper = x.querySelector(".discount-wrapper");
          if (discountWrapper) {
            const firstAdjustment = discountWrapper.getAttribute("data-first-adjustment");
            const secondAdjustment = discountWrapper.getAttribute("data-second-adjustment");
            var hasFirstOrderPrice = firstAdjustment !== secondAdjustment;
          }
          
          // Liquid renders the correct price into this span; only overwrite it when
          // a numeric source exists, otherwise formatMoney(null) prints "$0".
          if (regularP != null && regularP !== '') {
            x.querySelector('label [data-grp-price]').textContent = Utility.formatMoney(regularP, window.globalVariables.money_format);
          }
          if(x.querySelector(".dynamic-sales-message")){
            x.querySelector(".dynamic-sales-message").classList.add("d-none"); // hide the dynamic sales message
          }

          // Only show compare price if it exists, is greater than 0, and is greater than the regular price
          const regularPriceVal = parseFloat(regularP) || 0;
          const comparePriceVal = comparePrice ? parseFloat(comparePrice) : 0;
          const shouldShowComparePrice = comparePrice != '' && comparePriceVal > 0 && comparePriceVal > regularPriceVal;

          if(shouldShowComparePrice){
            x.querySelector("label [data-grp-com-price]").classList.remove("d-none");
            // we need to have something that still shows the sale
            x.querySelector("label [data-grp-com-price]").textContent = Utility.formatMoney(comparePrice, window.globalVariables.money_format);
          } else {
            x.querySelector("label [data-grp-com-price]").classList.add("d-none");
          }

          // Update data-variant-discount-percent for onetime (compare price discount only)
          let comparePriceValue = parseFloat(comparePrice || 0);
          let regularPriceValue = parseFloat(regularP);
          
          if(comparePriceValue > regularPriceValue) {
            let compareDiscountPercent = Math.floor(((comparePriceValue - regularPriceValue) / comparePriceValue) * 100);
            if (compareDiscountPercent > 0) {
              x.querySelector('label [data-variant-discount-percent]').innerHTML = compareDiscountPercent + "%";
              if (discountWrapper) {
                discountWrapper.classList.remove("d-none");
              }
            } else {
              x.querySelector('label [data-variant-discount-percent]').innerHTML = "0%";
              if (discountWrapper) {
                discountWrapper.classList.add("d-none");
              }
            }
          } else {
            x.querySelector('label [data-variant-discount-percent]').innerHTML = "0%";
            if (discountWrapper) {
              discountWrapper.classList.add("d-none");
            }
          }

          // Triggers on one time click
          if(comparePriceValue > regularPriceValue){
            x.querySelector(".discount-wrapper").classList.remove("d-none");
          }else{
            x.querySelector(".discount-wrapper").classList.add("d-none");
          }
          
        });
      }

  // Update shipping text for onetime products (in case single-variant products default to onetime)
  const shippingTextElement = this.form.querySelectorAll('[data-shipping-text]');
  
  
  
  if (shippingTextElement) {
    // For onetime, use current variant's compare price instead of potentially stale attribute
    const currentVariant = window.globalVariables?.product?.currentVariant;
    let comparePrice = 0;
    
    if (currentVariant && currentVariant.compare_at_price) {
      comparePrice = currentVariant.compare_at_price;
    } else {
      // Fallback to attribute if no current variant
      const onetimePriceElement = this.form.querySelector('[data-onetime-price]');
      const comparePriceAttr = onetimePriceElement?.getAttribute("onetime_compare_price");
      comparePrice = comparePriceAttr ? parseFloat(comparePriceAttr.replace(/[^0-9.-]+/g, "")) * 100 : 0;
    }

    if (currentVariant && comparePrice > 0 && comparePrice > currentVariant.price) {
      const currentVariantPrice = currentVariant.price;
      const comparePriceDiscount = comparePrice - currentVariantPrice;
      const ship_rate = currentVariant.metafields?.shipping_rate * 100 || 0;

      if (ship_rate > 0) {
        const totalSavingsPercentage = Math.floor(((comparePrice - currentVariantPrice) / comparePrice) * 100);
        const totalDis = Utility.formatMoney((comparePriceDiscount + ship_rate), window.globalVariables.money_format);
        shippingTextElement.forEach(element => {
          if (element.closest('[data-purchase_type="subscription"]')) return;
          const sep = element.classList.contains('freq-deal-banner') ? ' ' : '<br/> ';
          // element.innerHTML = `${totalSavingsPercentage}% off + Free Shipping${sep}${totalDis} Total Savings`;
          element.innerHTML = `${totalSavingsPercentage}% off + Free US Shipping`;
        });
      }
      // no-op when ship_rate is 0: preserve existing shipping text
    }
    // no-op when compare price is unavailable: preserve existing shipping text

       // Change the price of the subscription discount on change of supply
       // Guard every hop: on mobile/Instagram webviews the radio may not be inside an <li>
       const planComparePriceObj = document.querySelector('input[type="radio"][name="Supply"]:checked')
         ?.closest('li, fieldset, [data-option], [data-supply-card]')
         ?.querySelector('[data-plan-com-price]')
         ?.getAttribute('data-plan-com-price');
       const onetimePriceElement = document.querySelector('[data-onetime-pricen]');
       
       if(onetimePriceElement && planComparePriceObj) {
         onetimePriceElement.textContent = Utility.formatMoney(planComparePriceObj, window.globalVariables.money_format);
       }
    
  }

    }else{
      // When switching back to subscription, keep the user's selected frequency (e.g. 8 weeks) instead of resetting to default
      const selectedPlanInput = this.form.querySelector('[data-purchase_type="subscription"] custom-select ul input[type="radio"]:checked') ||
        this.form.querySelector('[data-purchase_type="subscription"] input[name="selling_plan_group"]:checked') ||
        this.form.querySelector('[data-purchase_type="subscription"] .selling_plan li.selected input');
      const sellingPlanInput = this.form.querySelector('[data-purchase_type="subscription"] input[name="selling_plan"]');
      if (selectedPlanInput && selectedPlanInput.value && sellingPlanInput) {
        sellingPlanInput.value = selectedPlanInput.value;
      }

      // Get current variant to ensure we use the latest variant's pricing
      const currentVariant = window.globalVariables?.product?.currentVariant;
      const productContainer = this.form.closest('[data-product-container]');
      const subscriptionPriceEl = this.form.querySelector('[data-subscription_price]');
      let subscription_price = subscriptionPriceEl?.innerHTML || '';
      productContainer?.querySelector('[data-current-price]') && (productContainer.querySelector('[data-current-price]').innerHTML = subscription_price);

      // Use current variant's selling_plan_allocations compare_at_price instead of potentially stale attribute
      let subscription_compare_price = '';
      if (currentVariant && currentVariant.compare_at_price) {
        // For subscription products, use the original product compare_at_price, not the selling plan one
        subscription_compare_price = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
      } else if (currentVariant && currentVariant.selling_plan_allocations && currentVariant.selling_plan_allocations.length > 0 && currentVariant.selling_plan_allocations[0].compare_at_price) {
        // Fallback to selling plan compare price only if no original compare price
        subscription_compare_price = Utility.formatMoney(currentVariant.selling_plan_allocations[0].compare_at_price, window.globalVariables.money_format);
      } else {
        // Fallback to attribute if no current variant
        subscription_compare_price = subscriptionPriceEl?.getAttribute("subscription_compare_price") || '';
      }
      productContainer?.querySelector('[data-current-com-price]') && (productContainer.querySelector('[data-current-com-price]').innerHTML = subscription_compare_price);

      // Update future subscription price (10% off compare_at_price)
      const futureSubscriptionPriceElement = document.querySelector('[data-future-subscription-price]');
      if (futureSubscriptionPriceElement) {
        // Use current variant's selling_plan_allocations compare_at_price instead of stale attribute
        let comparePrice = null;
        if (currentVariant && currentVariant.selling_plan_allocations && currentVariant.selling_plan_allocations.length > 0 && currentVariant.selling_plan_allocations[0].compare_at_price) {
          comparePrice = currentVariant.selling_plan_allocations[0].compare_at_price / 100; // Convert from cents to dollars
        } else if (currentVariant && currentVariant.compare_at_price) {
          comparePrice = currentVariant.compare_at_price / 100; // Convert from cents to dollars
        } else {
          // Fallback to attribute if no current variant.
          // Note: string parsing only works for "$" formats; prefer numeric
          // variant data as in _changeSellingPlan for non-USD safety.
          const comparePriceText = this.form.querySelector('[data-onetime-price]')?.getAttribute("onetime_compare_price");
          if (comparePriceText && comparePriceText.length > 0) {
            comparePrice = parseFloat(comparePriceText.replace('$', '').replace(',', ''));
          }
        }
        
        if (comparePrice) {
          const futureSubscriptionPrice = comparePrice * 0.9; // 10% off compare price
          futureSubscriptionPriceElement.textContent = Utility.formatMoney(futureSubscriptionPrice * 100, window.globalVariables.money_format);
        }
      }

      // Update shipping text for subscription products
      const shippingTextElement = this.form.querySelectorAll('[data-shipping-text]');

      // Declare hoisted variables so they are accessible after the if-block below.
      let disV = 0;
      let discountPercentage = 0;

      if (shippingTextElement) {
        // Get discount value from recharge widget
        const rechargeInput = this.form.querySelector('recharge-widget custom-select ul li input');

        disV = rechargeInput ? parseFloat(rechargeInput.getAttribute('data-discount')) || 0 : 0;

        // Get current variant data first.
        // currentVariant is set by VariantSelects.onVariantChange(), which may not have fired yet
        // on the 100ms init call. Fall back to the variants array (always available from Liquid)
        // so the compare_at_price discount is computed correctly on initial load.
        const urlVariantId = parseInt(new URLSearchParams(window.location.search).get('variant'));
        const allVariants = window.globalVariables?.product?.variants;
        const currentVariant = window.globalVariables?.product?.currentVariant
          || (urlVariantId && allVariants?.find(v => v.id === urlVariantId))
          || allVariants?.[0];

        // Get the compare price (original price before any discounts)
        let comparePrice;
        if (currentVariant?.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
          // Use Shopify's compare_at_price if it's higher than current price (real discount)
          comparePrice = currentVariant.compare_at_price;
        } else {
          // Fall back to Recharge's compare_at_price
          comparePrice = currentVariant?.selling_plan_allocations?.[0]?.compare_at_price;
        }

        // Get the current subscription price
        const subscriptionPrice = currentVariant?.selling_plan_allocations?.[0]?.price ?? currentVariant?.price ?? 0;

         // Calculate the percentage discount
         if(comparePrice && comparePrice > subscriptionPrice) {
           discountPercentage = Math.floor(((comparePrice - subscriptionPrice) / comparePrice) * 100);
         }
         
          
          if (currentVariant) {
            // Calculate shipping rate
            let ship_rate = currentVariant.metafields?.shipping_rate * 100 || 0;
            
            
            let vPrice = comparePrice * disV / 100;  // Recharge discount
            
            
            if (comparePrice > 0) {
              // Get the actual subscription price (should be from selling_plan_allocations[0].price)
              const subscriptionPriceElement = this.form.querySelector('[data-subscription_price]');
              const subscriptionPriceText = subscriptionPriceElement ? subscriptionPriceElement.innerHTML : '';
            
              
              // Only feeds the savings text. String parsing only works for "$"
              // formats; prefer numeric variant data as in _changeSellingPlan.
              const subscriptionPrice = subscriptionPriceText ? parseFloat(subscriptionPriceText.replace('$', '').replace(',', '')) * 100 : currentVariant.price;
            
              
                           // Use the discount percentage we calculated above
             const totalSavingsPercentage = discountPercentage || disV;
            
              
              const comparePriceDiscount = comparePrice - subscriptionPrice;  // Savings from compare price to subscription price
            
              
              let totalDis = Utility.formatMoney((comparePriceDiscount + ship_rate), window.globalVariables.money_format);
              
              
            // Update shipping text
            if ((ship_rate + vPrice) > 0) {
              shippingTextElement.forEach(element => {
                const sep = element.classList.contains('freq-deal-banner') ? ' ' : '<br/> ';
                // element.innerHTML = `${totalSavingsPercentage}% off + Free Shipping${sep}${totalDis} Total Savings`;
                element.innerHTML = `${totalSavingsPercentage}% off + Free US Shipping`;
              });
            } else {
              shippingTextElement.forEach(element => {
                if (!element.classList.contains('freq-deal-banner')) element.innerHTML = ' ';
              });
            }
          } else if ((ship_rate + vPrice) > 0) {
            // No compare price, but show shipping/subscription savings if available
            let totalDis = Utility.formatMoney((ship_rate + vPrice), window.globalVariables.money_format);
            let discountText = [];
            if (vPrice > 0) discountText.push(`${disV}% subscription discount`);
            if (ship_rate > 0) discountText.push('Free US Shipping');

            shippingTextElement.forEach(el => {
              const sep = el.classList.contains('freq-deal-banner') ? ' ' : '<br/> ';
              // el.innerHTML = `${discountText.join(' + ')}${sep}${totalDis} Total Savings`;
              el.innerHTML = `${discountText.join(' + ')}`;
            });
          } else {
            shippingTextElement.forEach(el => { if (!el.classList.contains('freq-deal-banner')) el.innerHTML = ' '; });
          }
        } else {
          shippingTextElement.forEach(el => { if (!el.classList.contains('freq-deal-banner')) el.innerHTML = ' '; });
        }
      }

      // Check if there's a real discount (compare price > subscription price)
      const subscriptionPriceValue = parseFloat(subscription_price.replace(/[^0-9.-]+/g, ""));
      const subscriptionComparePriceValue = subscription_compare_price ? parseFloat(subscription_compare_price.replace(/[^0-9.-]+/g, "")) : 0;
      const hasRealSubscriptionDiscount = subscription_compare_price && subscription_compare_price.length > 0 && subscriptionComparePriceValue > subscriptionPriceValue;
      
      const subscriptionCurrentPriceElement = this.form.closest('[data-product-container]')?.querySelector('[data-current-price]');
      const subscriptionCompareOutPriceElement = this.form.closest('[data-product-container]')?.querySelector('[data-current-com-price]');
      
      if (hasRealSubscriptionDiscount) {
        // Show discount styling: sale text and crossed-out compare price
        if (subscriptionCurrentPriceElement) {
          subscriptionCurrentPriceElement.classList.add('rc-price--sale');
        }
        if (subscriptionCompareOutPriceElement) {
          subscriptionCompareOutPriceElement.style.display = '';
        }
      } else {
        // No real discount: remove sale styling and hide crossed-out price
        if (subscriptionCurrentPriceElement) {
          subscriptionCurrentPriceElement.classList.remove('rc-price--sale');
        }
        if (subscriptionCompareOutPriceElement) {
          subscriptionCompareOutPriceElement.style.display = 'none';
        }
      }

      // Create button text based on sold out state
      const subscribeDiscount = discountPercentage || disV;
      const buttonText = isSoldOut
        ? window.variantStrings.soldOut
        : subscribeDiscount ? `Subscribe & save ${subscribeDiscount}%` : 'Subscribe & save';

      // Update main add to cart button
      this.form.closest('[data-product-container]').querySelector('[name="add"] .add-text').innerHTML = buttonText;
      this.form.closest('[data-product-container]').querySelector('[name="add"]').disabled = isSoldOut;

      // Update sticky add to cart buttons
      document.querySelectorAll('[data-atc-out]')?.forEach(ele => {
        ele.innerHTML = `<span class="add-text">${buttonText}</span><span class="spinner-border block__add-to-cart-spinner"></span>`;
        ele.disabled = isSoldOut;
      });

      // Update sticky product details button
      const stickyButton = document.querySelector('.product-sticky-container [data-atc-out]');
      if (stickyButton) {
        stickyButton.innerHTML = `<span class="add-text">${buttonText}</span><span class="spinner-border block__add-to-cart-spinner"></span>`;
        stickyButton.disabled = isSoldOut;
      }

      let $variantGRP = null;
      if(this.form.querySelector('[data-optionindex="2"]')){
        $variantGRP = this.form.querySelectorAll('[data-optionindex="2"] ul li');
      } else {
        $variantGRP = this.form.querySelectorAll('[data-optionindex="1"] ul li');
      }

      if($variantGRP != null){
        $variantGRP.forEach((x) => {
          const grpPriceElement = x.querySelector('label [data-grp-price]');
          const grpComPriceElement = x.querySelector('label [data-grp-com-price]');
          const rechargeInput = this.form.querySelector('recharge-widget custom-select ul li input');
          
          if (!grpPriceElement || !grpComPriceElement || !rechargeInput) return;
          
          let regularP = grpPriceElement.getAttribute('data-regular-price');
          let compareP = grpComPriceElement.getAttribute('data-regular-com-price');
          let dis = rechargeInput.getAttribute('data-discount') || 0;
          let discountPercentage = parseFloat(dis);
          
          // Get the actual variant data to access selling_plan_allocations
          const labelElement = x.querySelector('label');
          const variantTitle = labelElement ? labelElement.getAttribute('title') : null;
          
          // Find the corresponding variant from window.globalVariables or from variant data
          let displayPrice = regularP;
          if (variantTitle && window.globalVariables?.product?.variants) {
            const matchingVariant = window.globalVariables.product.variants.find(v => {
              // Match by option1 or option2 depending on which option this is
              return v.option1 === variantTitle || v.option2 === variantTitle;
            });
            
            if (matchingVariant && matchingVariant.selling_plan_allocations && matchingVariant.selling_plan_allocations.length > 0) {
              displayPrice = matchingVariant.selling_plan_allocations[0].price;
            } else {
              // Fallback to manual calculation if selling plan data not available
              displayPrice = regularP - (regularP * discountPercentage / 100);
              displayPrice = Math.round(displayPrice);
            }
          } else {
            // Fallback to manual calculation
            displayPrice = regularP - (regularP * discountPercentage / 100);
            displayPrice = Math.round(displayPrice);
          }
          
          let discountPercent = Math.floor(((compareP - displayPrice) / compareP) * 100);
      
          x.querySelector('label [data-grp-price]').textContent = Utility.formatMoney(displayPrice, window.globalVariables.money_format);
          x.querySelector("label [data-variant-discount]").innerHTML = discountPercentage+"%";

          // Check if there's a meaningful discount difference
          const discountWrapper = x.querySelector(".discount-wrapper");
          if (discountWrapper) {
            const firstAdjustment = discountWrapper.getAttribute("data-first-adjustment");
            const secondAdjustment = discountWrapper.getAttribute("data-second-adjustment");
            var hasFirstOrderPrice = firstAdjustment !== secondAdjustment;
          }

          let finalDiscountPercent = 0;
          
          if(compareP < regularP) {
            finalDiscountPercent = discountPercentage;
            x.querySelector('label [data-variant-discount-percent]').innerHTML = discountPercentage + "%";
          }else{
            finalDiscountPercent = discountPercent;
            x.querySelector('label [data-variant-discount-percent]').innerHTML = discountPercent +"%";
          }

          // Triggers on subscription click - show discount wrapper when there's a discount (including dynamic pricing)
          if(finalDiscountPercent > 0){
            if (discountWrapper) {
              discountWrapper.classList.remove("d-none");
            }
          }else{
            if (discountWrapper) {
              discountWrapper.classList.add("d-none");
            }
          }

          let plancomparePrice = x.querySelector("label [data-grp-com-price]").getAttribute("data-plan-com-price");
          
          // Only show compare price if it exists, is greater than 0, and is greater than the display price
          const planComparePriceValue = plancomparePrice ? parseFloat(plancomparePrice) : 0;
          const displayPriceValue = parseFloat(displayPrice) || 0;
          const shouldShowPlanComparePrice = plancomparePrice != '' && planComparePriceValue > 0 && planComparePriceValue > displayPriceValue;
          
          if(shouldShowPlanComparePrice){
            x.querySelector("label [data-grp-com-price]").classList.remove("d-none");
            x.querySelector("label [data-grp-com-price]").textContent = Utility.formatMoney(plancomparePrice, window.globalVariables.money_format);
          }else{
            x.querySelector("label [data-grp-com-price]").classList.add("d-none");
          }
        });
        // Change the price of the subscription discount on change of supply
        // Guard every hop: on mobile/Instagram webviews the radio may not be inside an <li>
        const planComparePriceObj = document.querySelector('input[type="radio"][name="Supply"]:checked')
          ?.closest('li, fieldset, [data-option], [data-supply-card]')
          ?.querySelector('[data-plan-com-price]')
          ?.getAttribute('data-plan-com-price');
        const onetimePriceElement = document.querySelector('[data-onetime-pricen]');
        if(onetimePriceElement && planComparePriceObj) {
          onetimePriceElement.textContent = Utility.formatMoney(planComparePriceObj, window.globalVariables.money_format);
        }
      }

    }
  }

  /**
   * Filter selling plans based on current variant's available plans
   * This method will hide/show plan options based on what's available for the selected variant
   */
  filterSellingPlansForVariant() {
    const currentVariant = window.globalVariables?.product?.currentVariant;
    if (!currentVariant || !currentVariant.selling_plan_allocations) {
      return;
    }

    // Get all plan options in the recharge widget
    const planOptions = this.querySelectorAll('custom-select ul li');
    const availablePlanIds = currentVariant.selling_plan_allocations.map(allocation => allocation.selling_plan_id.toString());

    let hasVisiblePlans = false;
    let firstVisiblePlan = null;

    planOptions.forEach((li, index) => {
      const input = li.querySelector('input[type="radio"]');
      const planId = input?.value;
      const isAvailable = availablePlanIds.includes(planId);
      
      if (isAvailable) {
        li.style.display = '';
        li.classList.remove('d-none');
        if (!hasVisiblePlans) {
          hasVisiblePlans = true;
          firstVisiblePlan = li;
        }
      } else {
        li.style.display = 'none';
        li.classList.add('d-none');
        // Uncheck hidden plans
        if (input) {
          input.checked = false;
        }
      }
    });

    // If we have visible plans, select the first one if none are currently selected
    if (hasVisiblePlans && firstVisiblePlan) {
      const checkedInput = this.querySelector('custom-select ul li input:checked');
      if (!checkedInput || checkedInput.closest('li').style.display === 'none') {
        const firstInput = firstVisiblePlan.querySelector('input[type="radio"]');
        if (firstInput) {
          firstInput.checked = true;
          firstVisiblePlan.classList.add('selected');
          // Update the dropdown text
          const optionText = this.querySelector('.option_txt');
          if (optionText) {
            optionText.textContent = firstVisiblePlan.getAttribute('data-value');
          }
        }
      }
    }

    // Update the dropdown text to show the selected plan
    const selectedPlan = this.querySelector('custom-select ul li.selected');
    if (selectedPlan && selectedPlan.style.display !== 'none') {
      const optionText = this.querySelector('.option_txt');
      if (optionText) {
        optionText.textContent = selectedPlan.getAttribute('data-value');
      }
    }
  }

  _changeSellingPlan(event){
    let target = event.target;
    if (!target.closest('recharge-widget')) {
      target = event.target.closest('product-form')?.querySelector('recharge-widget custom-select ul li input');
    }
    
    if (!target) return;

    let id = target.value;
    let dis = target.getAttribute('data-discount') || 0;

    // Read prices as cents from the variant JSON, never from the formatted DOM
    // text. In a non-USD presentment currency (Shopify Markets local currencies)
    // the rendered price is e.g. "CA$79.00"; stripping a literal "$" and calling
    // parseFloat yields NaN, and Utility.formatMoney renders NaN as "$0", which
    // then sticks because later code copies [data-subscription_price] back into
    // [data-current-price] on every variant change.
    const urlVariantId = parseInt(new URLSearchParams(window.location.search).get('variant'));
    const allVariants = window.globalVariables?.product?.variants;
    const cv = window.globalVariables?.product?.currentVariant
      || (urlVariantId && allVariants?.find(v => v.id === urlVariantId))
      || allVariants?.[0];
    if (!cv) return; // No numeric source; leave the Liquid-rendered price alone.

    // Shopify already applied the plan adjustment to the allocation price, so
    // prefer the allocation for the chosen plan. Fall back to the first
    // allocation, then to percentage math on the one-time price.
    const allocation = cv.selling_plan_allocations?.find(a => String(a.selling_plan_id) === String(id))
      || cv.selling_plan_allocations?.[0];
    const discountedCents = allocation?.price != null
      ? allocation.price
      : Math.round(cv.price * (1 - (parseFloat(dis) || 0) / 100));
    const formattedPrice = Utility.formatMoney(discountedCents, window.globalVariables.money_format);

    target.closest('[data-purchase_type]').querySelector('[name="selling_plan"]').value=id;
    // target.closest('[data-purchase_type]').querySelector('[data-subscription_percentage]').innerHTML=`${dis}%`;
    target.closest('[data-purchase_type]').querySelector('[data-subscription_price]').innerHTML = formattedPrice;
    target.closest('[data-product-container]').querySelector('[data-current-price]').innerHTML = formattedPrice;
    // Use compare_at_price math for the button label (matches _toggleOptions logic).
    // data-discount is Recharge's plan discount (e.g. 12.5%) which differs from the
    // total savings vs compare_at_price (e.g. 30%). Prefer the latter.
    const capPrice = cv?.compare_at_price;
    const subPrice = cv?.selling_plan_allocations?.[0]?.price ?? cv?.price;
    const actualDis = (capPrice && subPrice && capPrice > subPrice)
      ? Math.floor(((capPrice - subPrice) / capPrice) * 100)
      : parseFloat(dis) || 0;
    target.closest('[data-product-container]').querySelector('[name="add"] .add-text').innerHTML = actualDis ? `Subscribe & save ${actualDis}%` : 'Subscribe & save';

  }
}
customElements.define('recharge-widget', rechargeWidget);
